import { motion } from "framer-motion";

function HeroSection() {
  return (
    <section className="relative bg-blue-900 text-white pt-20 pb-16 sm:pt-24 sm:pb-20 overflow-hidden">
      {/* Decorative flags */}
      <div className="absolute top-10 left-10 text-7xl opacity-10 select-none" aria-hidden="true">🇺🇸</div>
      <div className="absolute bottom-10 right-10 text-7xl opacity-10 select-none animate-float" aria-hidden="true">🇬🇧</div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-4">

          Pare de começar inglês do zero todo ano.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="text-xl sm:text-2xl md:text-3xl font-bold text-yellow-400 mb-4">Aprenda Inglês pelo Whatsapp com o EW PASS e Lucy IA


        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="text-base sm:text-lg text-blue-200 mb-8 max-w-2xl mx-auto">

          Você não precisa de mais um curso. Precisa de estrutura, prática e acompanhamento certo.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mb-8">

          <a
            href="#cta-final"
            className="inline-block bg-yellow-400 text-blue-900 font-extrabold text-lg sm:text-xl px-8 py-4 rounded-xl hover:bg-yellow-300 transition-colors animate-pulse-glow">👉 Começar agora!


          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-sm sm:text-base text-blue-100 mb-10">

          <span>✔️ Base sólida para a sua evolução</span>
          <span>✔️ Acesso completo a todos os recursos</span>
          <span>✔️ Estrutura validada por mais de 10.000 alunos</span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="flex justify-center">

          








        </motion.div>
      </div>
    </section>);

}

export default HeroSection;